module.exports = __webpack_public_path__ + "img/frame (271).b2e8a855.jpg";